<div class="toolbar-container">
  <div class="left">
    <h2>{{title}}</h2>
    <ng-container *ngIf="profile && pageActions?.length">
      <ng-container *ngFor="let action of pageActions">
        <div ripple class="button" (click)="!action.options.disabled ? action.options.callback($event) : null"
             *ngIf="!action.options.hidden" [ngClass]="action.options.type">
          <mat-icon>{{action.options.icon}}</mat-icon>
          <span *ngIf="!action.options.translationString">{{action.options.title}}</span>
          <span *ngIf="action.options.translationString">{{action.options.translationString | translate}}</span>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="right">
    <ng-container *ngIf="topActionButton?.length">
      <ng-container *ngIf="topActionButton.length === 1">
        <div ripple class="button" *ngFor="let button of topActionButton" (click)="open(button)">
          <mat-icon>{{button.icon}}</mat-icon>
          {{'general.topActionButtons.' + (button.subType === 'qrCode' ? 'qrCode.' : '') + button.type | translate}}
        </div>
      </ng-container>
      <ng-container *ngIf="topActionButton.length > 1">
        <mat-menu #outputMenu="matMenu">
          <button *ngFor="let button of topActionButton" mat-menu-item class="output-button" (click)="open(button)">
            <mat-icon>{{button.icon}}</mat-icon>
            {{'general.topActionButtons.' + (button.subType === 'qrCode' ? 'qrCode.' : '') + button.type | translate}}
          </button>
        </mat-menu>
        <button ripple [matMenuTriggerFor]="outputMenu"><mat-icon>visibility</mat-icon>
          <span>Ausgaben anzeigen</span>
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>
